import React from 'react'

import { Link, Button } from '@superlogica/button'
import PropTypes from 'prop-types'

import Icon from '../../helpers/Icon'
import Illustration from '../../helpers/Illustration'
import * as S from './styled'

const Feature = ({
  className,
  headText,
  bodyText,
  action,
  align,
  bgColor,
  illustration,
  zindex,
  translateY,
  ...props
}) => {
  let SelectedButton = null

  if (action) {
    SelectedButton = action.appearance === 'link' ? Link : Button
  }

  return (
    <S.FeatureWrapper
      className={`feature ${className}`}
      align={align}
      padding={32}
      bgColor={bgColor}
      zindex={zindex}
      translateY={translateY}
      {...props}
    >
      {illustration && (
        <S.FeatureFigure>
          <Illustration name={illustration} />
        </S.FeatureFigure>
      )}

      <S.FeatureCaption>
        <S.FeatureTitle>{headText}</S.FeatureTitle>
        <S.FeatureText>{bodyText}</S.FeatureText>
      </S.FeatureCaption>

      <S.FeatureFooting>
        {action && (
          <SelectedButton
            className="d-xs-block has-icon-right"
            href={action.to}
            as="a"
            title={action.label}
            color={action.color || 'blue500'}
          >
            {action.label}
            <Icon
              name="arrow-right-1"
              color={bgColor === 'ghost' ? action.color : 'white'}
              size={10}
            />
          </SelectedButton>
        )}
      </S.FeatureFooting>
    </S.FeatureWrapper>
  )
}

Feature.defaultProps = {
  light: false,
  align: 'center',
  bgColor: 'white'
}

Feature.propTypes = {
  className: PropTypes.string,
  headText: PropTypes.string.isRequired,
  bodyText: PropTypes.string.isRequired,
  action: PropTypes.object,
  illustration: PropTypes.string,
  align: PropTypes.string,
  bgColor: PropTypes.string,
  light: PropTypes.bool,
  zindex: PropTypes.number,
  translateY: PropTypes.number
}

export default Feature
